import BaseApiService from '../baseApi.service';

export default class ConfigurationService extends BaseApiService {
  readonly basePath: string = 'configuration/v1';
  constructor(props = null) {
    super(props);
  }
}
